const SECTION_SELECTORS = [
    '.c-cards-estate__top-main',
    '.c-cards-estate__name',
    '.c-cards-estate-features__item[data-type="address"]',
    '.c-cards-estate-features__item[data-type="access"]',
];

const clearHeights = (cards) => {
    cards.forEach((card) => {
        SECTION_SELECTORS.forEach((selector) => {
            const el = card.querySelector(selector);
            if (el) el.style.minHeight = '';
        });
    });
};

const groupCardsByRow = (cards) => {
    const rows = [];
    cards.forEach((card) => {
        const top = Math.round(card.getBoundingClientRect().top);
        let row = rows.find((entry) => Math.abs(entry.top - top) <= 2);
        if (!row) {
            row = { top, cards: [] };
            rows.push(row);
        }
        row.cards.push(card);
    });
    return rows;
};

const equalizeRow = (cards) => {
    SECTION_SELECTORS.forEach((selector) => {
        const els = cards
            .map((card) => card.querySelector(selector))
            .filter(Boolean);
        if (els.length === 0) return;

        els.forEach((el) => {
            el.style.minHeight = '';
        });
        const max = Math.max(...els.map((el) => el.getBoundingClientRect().height), 0);
        if (max <= 0) return;
        els.forEach((el) => {
            el.style.minHeight = `${Math.ceil(max)}px`;
        });
    });
};

const alignPickupCards = (root) => {
    const cards = [...root.querySelectorAll('.c-cards-estate')];
    if (cards.length === 0) return;

    clearHeights(cards);
    // クリア後の自然高で行判定・揃え
    requestAnimationFrame(() => {
        groupCardsByRow(cards).forEach((row) => {
            if (row.cards.length > 1) {
                equalizeRow(row.cards);
            }
        });
    });
};

const main = () => {
    const root = document.querySelector('#pickup');
    if (root == null) return;

    let timer = null;
    const schedule = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => alignPickupCards(root), 50);
    };

    // 画像読み込み後にも再計算。カードはAjaxで差し込まれるので複数回呼ばれる
    const watchImages = () => {
        root.querySelectorAll('.c-cards-estate__gallery img').forEach((img) => {
            if (img.complete) return;
            if (img.dataset.pickupAlignWatched) return;
            img.dataset.pickupAlignWatched = '1';
            img.addEventListener('load', schedule, { once: true });
        });
    };

    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { passive: true });

    if (document.fonts?.ready) {
        document.fonts.ready.then(schedule).catch(() => {});
    }

    watchImages();

    // カードリスト（pages.home._pickup-cards）はAjaxで後から入る。
    // 差し込み完了時に高さ揃えをやり直し、新しい画像も監視対象に加える。
    // onLoadContents はバブルしないのでプレースホルダ要素に直接張る
    root.querySelectorAll('.js-load-contents').forEach((el) => {
        el.addEventListener('onLoadContents', () => {
            watchImages();
            schedule();
        });
    });
};

export default main;
